export const environment = {
  production: false,
  appId: 'HAL',
  appKey: 'T331)iCu.e3<^m~j.',
  home_url: 'https://pre-hal.aragon.es',
  url: 'https://pre.hal.aragon.es',
  spdfBaseUrl: 'https://spdf-core-pre-generapdf.apps.pre.aragon.es',
  url_serv: 'preaplicaciones.aragon.es/mfe_core',
  urlGetToken: 'https://pre.hal.aragon.es',
  environment: 'PRE_',
  urlDetail: 'https://preaplicaciones.aragon.es/seda/service/detail',
};
